function bookings_step1() {
  var self = this;

  this.init = function () {

    this.validateApplication();
    this.bindEvents();

  }

  this.validateApplication = function () {

    $("#bookings_step1").validate({

      onfocusout: false,
      onkeyup: false,
      onclick: false,

      // Make sure error messages relating to radio buttons are placed in the correct location
      errorPlacement: function(error, element) {
        if (element.attr("type") == "checkbox") {
          error.prependTo(element.parents("div.bookings-terms-and-conditions, div.form-group"));
        } else {
          error.insertBefore(element);
        }
      },

      rules: {

      },

      messages: {
        member_number: {
          required: '<i class="fas fa-exclamation-circle" aria-hidden="true"></i><span class="sr-only">Error:</span> Enter your member number'
        },
        t_and_c: {
          required: '<i class="fas fa-exclamation-circle" aria-hidden="true"></i><span class="sr-only">Error:</span> Please accept the terms and conditions'
        },
        usage_confirm: {
          required: '<i class="fas fa-exclamation-circle" aria-hidden="true"></i><span class="sr-only">Error:</span> Please accept the usage requirements'
        }
      },

      submitHandler: function(form) {

        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#bookings_step1').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            form.submit();
          });
        });

      }

    });

  }

  this.bindEvents = function () {

  }

}

module.exports = bookings_step1;
